import { A } from '@mobily/ts-belt'
import { api, type EpgInfo } from '@setplex/tria-api'
import { attach, createEvent, sample } from 'effector'
import { NO_EPG_ID, type EpgRequestParams } from '../index.h'
import { isValidRange } from '../lib/ranges'

// event to guard calling actual fetch, in case of bad params
export const fetchEpgInfo = createEvent<EpgRequestParams>()

// event to fetch upcoming epg data
export const fetchProgramEpg = createEvent<EpgInfo>()

// actual fetch epg data effect
export const fetchEpgInfoFx = attach({
  effect: api.tv.getEpgInformationFormattedFx,
})

// actual fetch upcoming epg data effect
export const fetchProgramEpgFx = attach({
  effect: api.tv.getProgramEPGInfoFx,
})

// fetch epg data for channels for biggest calculated range
sample({
  clock: fetchEpgInfo,
  filter: ({ channels, period }) => channels.length > 0 && isValidRange(period),
  fn: ({ channels, period }) => {
    return {
      epgIds: A.uniq(A.map(channels, ({ epgId }) => epgId ?? NO_EPG_ID)),
      channels,
      period: { start: period![0], end: period![1] },
    }
  },
  target: fetchEpgInfoFx,
})

// fetch upcoming data by given epg program
sample({
  clock: fetchProgramEpg,
  fn: ({ epgId, title, startMs }) => ({
    epgId: String(epgId),
    programTitle: String(title),
    start: Number(startMs),
  }),
  target: fetchProgramEpgFx,
})
